import React from 'react';

// Cute house cleaning illustration in mint/teal palette
export function HouseIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 500 380" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Background circle */}
      <circle cx="250" cy="200" r="170" fill="#e6f7f4" />
      <circle cx="250" cy="200" r="140" fill="#d1efe9" opacity="0.6" />

      {/* Ground */}
      <ellipse cx="250" cy="330" rx="180" ry="14" fill="#4dbfae" opacity="0.15" />

      {/* House body */}
      <rect x="140" y="170" width="220" height="150" rx="6" fill="#ffffff" stroke="#1a2851" strokeWidth="3" />
      {/* Roof */}
      <polygon points="130,175 250,90 370,175" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" strokeLinejoin="round" />
      {/* Chimney */}
      <rect x="310" y="110" width="22" height="40" fill="#3ba798" stroke="#1a2851" strokeWidth="3" />

      {/* Door */}
      <rect x="225" y="235" width="50" height="85" rx="4" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />
      <circle cx="265" cy="280" r="3" fill="#1a2851" />

      {/* Left window */}
      <rect x="160" y="200" width="48" height="48" rx="3" fill="#bfeae2" stroke="#1a2851" strokeWidth="3" />
      <line x1="184" y1="200" x2="184" y2="248" stroke="#1a2851" strokeWidth="2" />
      <line x1="160" y1="224" x2="208" y2="224" stroke="#1a2851" strokeWidth="2" />

      {/* Right window */}
      <rect x="292" y="200" width="48" height="48" rx="3" fill="#bfeae2" stroke="#1a2851" strokeWidth="3" />
      <line x1="316" y1="200" x2="316" y2="248" stroke="#1a2851" strokeWidth="2" />
      <line x1="292" y1="224" x2="340" y2="224" stroke="#1a2851" strokeWidth="2" />

      {/* Sparkles */}
      <g fill="#ffb020">
        <path d="M110 130 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" />
        <path d="M400 220 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
        <path d="M90 260 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
      </g>

      {/* Cleaning bubbles */}
      <g fill="#ffffff" stroke="#4dbfae" strokeWidth="2">
        <circle cx="400" cy="140" r="12" />
        <circle cx="425" cy="170" r="7" />
        <circle cx="85" cy="180" r="9" />
      </g>
    </svg>
  );
}

// Office building illustration
export function OfficeIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 500 380" className={className} xmlns="http://www.w3.org/2000/svg">
      <circle cx="250" cy="200" r="170" fill="#e6f7f4" />
      <circle cx="250" cy="200" r="140" fill="#d1efe9" opacity="0.6" />
      <ellipse cx="250" cy="330" rx="180" ry="14" fill="#4dbfae" opacity="0.15" />

      {/* Building tall */}
      <rect x="170" y="100" width="90" height="220" fill="#ffffff" stroke="#1a2851" strokeWidth="3" />
      <rect x="260" y="150" width="90" height="170" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />

      {/* Windows tall */}
      {[0, 1, 2, 3, 4].map((row) => (
        <g key={`t-${row}`}>
          <rect x="182" y={115 + row * 42} width="22" height="28" fill="#bfeae2" stroke="#1a2851" strokeWidth="2" />
          <rect x="215" y={115 + row * 42} width="22" height="28" fill="#bfeae2" stroke="#1a2851" strokeWidth="2" />
        </g>
      ))}

      {/* Windows short */}
      {[0, 1, 2, 3].map((row) => (
        <g key={`s-${row}`}>
          <rect x="272" y={165 + row * 40} width="22" height="26" fill="#ffffff" stroke="#1a2851" strokeWidth="2" />
          <rect x="305" y={165 + row * 40} width="22" height="26" fill="#ffffff" stroke="#1a2851" strokeWidth="2" />
        </g>
      ))}

      {/* Door */}
      <rect x="200" y="270" width="30" height="50" rx="2" fill="#1a2851" />

      {/* Sparkles */}
      <g fill="#ffb020">
        <path d="M120 130 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" />
        <path d="M390 250 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
      </g>

      {/* Bubbles */}
      <g fill="#ffffff" stroke="#4dbfae" strokeWidth="2">
        <circle cx="110" cy="200" r="12" />
        <circle cx="85" cy="175" r="7" />
        <circle cx="400" cy="150" r="10" />
        <circle cx="425" cy="180" r="6" />
      </g>
    </svg>
  );
}

// Cleaner with mop
export function CleanerIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 500 400" className={className} xmlns="http://www.w3.org/2000/svg">
      <circle cx="250" cy="200" r="180" fill="#e6f7f4" />
      <ellipse cx="250" cy="355" rx="200" ry="14" fill="#4dbfae" opacity="0.15" />

      {/* Bubbles background */}
      <g fill="#ffffff" stroke="#4dbfae" strokeWidth="2.5" opacity="0.85">
        <circle cx="90" cy="120" r="18" />
        <circle cx="130" cy="90" r="10" />
        <circle cx="400" cy="110" r="14" />
        <circle cx="430" cy="150" r="8" />
        <circle cx="70" cy="250" r="12" />
      </g>

      {/* Body */}
      <ellipse cx="250" cy="350" rx="55" ry="6" fill="#1a2851" opacity="0.15" />

      {/* Legs */}
      <rect x="228" y="270" width="18" height="80" rx="6" fill="#1a2851" />
      <rect x="254" y="270" width="18" height="80" rx="6" fill="#1a2851" />

      {/* Torso - apron */}
      <path d="M210 180 Q210 155 250 155 Q290 155 290 180 L295 275 Q250 285 205 275 Z" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />
      <path d="M240 160 L250 175 L260 160" stroke="#1a2851" strokeWidth="2" fill="none" />

      {/* Right arm holding mop */}
      <path d="M290 190 Q320 200 335 230" stroke="#1a2851" strokeWidth="14" strokeLinecap="round" fill="none" />
      <path d="M290 190 Q320 200 335 230" stroke="#ffd9b8" strokeWidth="10" strokeLinecap="round" fill="none" />

      {/* Left arm */}
      <path d="M210 190 Q195 220 200 260" stroke="#1a2851" strokeWidth="14" strokeLinecap="round" fill="none" />
      <path d="M210 190 Q195 220 200 260" stroke="#ffd9b8" strokeWidth="10" strokeLinecap="round" fill="none" />

      {/* Head */}
      <circle cx="250" cy="125" r="32" fill="#ffd9b8" stroke="#1a2851" strokeWidth="3" />
      {/* Hair */}
      <path d="M220 120 Q222 90 250 90 Q278 90 280 120 Q280 108 260 105 Q245 108 240 115 Q230 110 220 120 Z" fill="#1a2851" />
      {/* Eyes */}
      <circle cx="240" cy="127" r="2.5" fill="#1a2851" />
      <circle cx="260" cy="127" r="2.5" fill="#1a2851" />
      {/* Smile */}
      <path d="M242 138 Q250 145 258 138" stroke="#1a2851" strokeWidth="2" fill="none" strokeLinecap="round" />

      {/* Mop stick */}
      <line x1="335" y1="230" x2="370" y2="340" stroke="#8b5a2b" strokeWidth="6" strokeLinecap="round" />
      {/* Mop head */}
      <ellipse cx="373" cy="345" rx="28" ry="10" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />
      <g stroke="#1a2851" strokeWidth="1.5">
        <line x1="355" y1="350" x2="353" y2="365" />
        <line x1="365" y1="353" x2="363" y2="370" />
        <line x1="375" y1="354" x2="375" y2="372" />
        <line x1="385" y1="353" x2="388" y2="370" />
        <line x1="393" y1="350" x2="398" y2="365" />
      </g>

      {/* Spray bottle in left hand */}
      <rect x="180" y="258" width="30" height="38" rx="4" fill="#ffb020" stroke="#1a2851" strokeWidth="2.5" />
      <rect x="188" y="250" width="14" height="10" fill="#1a2851" />
      <path d="M202 255 L215 245" stroke="#1a2851" strokeWidth="2" />

      {/* Sparkles */}
      <g fill="#ffb020">
        <path d="M410 260 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" />
        <path d="M50 190 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
      </g>
    </svg>
  );
}

// Living room illustration
export function LivingRoomIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 500 380" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="500" height="380" fill="#f2fbf9" />
      {/* Floor */}
      <rect x="0" y="280" width="500" height="100" fill="#e6f7f4" />
      {/* Wall separator */}
      <line x1="0" y1="280" x2="500" y2="280" stroke="#4dbfae" strokeWidth="2" />

      {/* Window */}
      <rect x="60" y="70" width="120" height="120" fill="#bfeae2" stroke="#1a2851" strokeWidth="3" />
      <line x1="120" y1="70" x2="120" y2="190" stroke="#1a2851" strokeWidth="2" />
      <line x1="60" y1="130" x2="180" y2="130" stroke="#1a2851" strokeWidth="2" />

      {/* Picture frame */}
      <rect x="330" y="90" width="90" height="70" fill="#ffffff" stroke="#1a2851" strokeWidth="3" />
      <path d="M340 145 L360 120 L380 138 L400 105 L410 145 Z" fill="#4dbfae" />
      <circle cx="400" cy="105" r="5" fill="#ffb020" />

      {/* Sofa */}
      <rect x="140" y="220" width="220" height="70" rx="10" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />
      <rect x="155" y="235" width="60" height="40" rx="6" fill="#7fe0ce" stroke="#1a2851" strokeWidth="2" />
      <rect x="220" y="235" width="60" height="40" rx="6" fill="#7fe0ce" stroke="#1a2851" strokeWidth="2" />
      <rect x="285" y="235" width="60" height="40" rx="6" fill="#7fe0ce" stroke="#1a2851" strokeWidth="2" />
      <rect x="140" y="280" width="12" height="20" fill="#1a2851" />
      <rect x="348" y="280" width="12" height="20" fill="#1a2851" />

      {/* Coffee table */}
      <rect x="210" y="310" width="80" height="10" rx="3" fill="#8b5a2b" stroke="#1a2851" strokeWidth="2" />
      <rect x="215" y="320" width="5" height="20" fill="#8b5a2b" />
      <rect x="280" y="320" width="5" height="20" fill="#8b5a2b" />

      {/* Cup on table */}
      <rect x="235" y="298" width="14" height="14" rx="2" fill="#ffffff" stroke="#1a2851" strokeWidth="2" />

      {/* Plant */}
      <rect x="40" y="260" width="36" height="40" rx="3" fill="#ffb020" stroke="#1a2851" strokeWidth="2.5" />
      <path d="M58 260 Q40 220 45 195 Q55 220 58 260" fill="#4dbfae" stroke="#1a2851" strokeWidth="2" />
      <path d="M58 260 Q76 220 71 200 Q60 225 58 260" fill="#7fe0ce" stroke="#1a2851" strokeWidth="2" />

      {/* Lamp */}
      <line x1="445" y1="200" x2="445" y2="300" stroke="#1a2851" strokeWidth="3" />
      <path d="M425 200 L465 200 L455 170 L435 170 Z" fill="#ffb020" stroke="#1a2851" strokeWidth="2.5" />
      <ellipse cx="445" cy="305" rx="18" ry="5" fill="#1a2851" />

      {/* Sparkles */}
      <g fill="#ffb020">
        <path d="M250 50 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" />
        <path d="M470 60 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
      </g>
    </svg>
  );
}

// Eco / green cleaning illustration
export function EcoIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 500 400" className={className} xmlns="http://www.w3.org/2000/svg">
      <circle cx="250" cy="200" r="180" fill="#e6f7f4" />
      <ellipse cx="250" cy="355" rx="200" ry="14" fill="#4dbfae" opacity="0.15" />

      {/* Big leaf circle background */}
      <circle cx="250" cy="200" r="110" fill="#7fe0ce" opacity="0.4" />

      {/* Spray bottle - green */}
      <rect x="200" y="170" width="90" height="140" rx="12" fill="#4dbfae" stroke="#1a2851" strokeWidth="3" />
      <rect x="225" y="140" width="40" height="30" fill="#3ba798" stroke="#1a2851" strokeWidth="3" />
      <path d="M265 155 L305 130 L305 145 L275 168 Z" fill="#1a2851" />
      {/* Label */}
      <rect x="215" y="210" width="60" height="70" rx="3" fill="#ffffff" stroke="#1a2851" strokeWidth="2" />
      {/* Leaf on label */}
      <path d="M245 220 Q265 235 245 260 Q225 235 245 220 Z" fill="#4dbfae" stroke="#1a2851" strokeWidth="2" />
      <line x1="245" y1="225" x2="245" y2="258" stroke="#1a2851" strokeWidth="1.5" />

      {/* Falling leaves */}
      <g stroke="#1a2851" strokeWidth="2">
        <path d="M120 100 Q140 115 120 140 Q100 115 120 100 Z" fill="#7fe0ce" />
        <path d="M380 130 Q400 145 380 170 Q360 145 380 130 Z" fill="#4dbfae" />
        <path d="M90 250 Q108 262 92 285 Q76 262 90 250 Z" fill="#7fe0ce" />
        <path d="M410 260 Q426 272 412 295 Q396 272 410 260 Z" fill="#4dbfae" />
      </g>

      {/* Bubbles */}
      <g fill="#ffffff" stroke="#4dbfae" strokeWidth="2">
        <circle cx="320" cy="90" r="14" />
        <circle cx="350" cy="120" r="8" />
        <circle cx="150" cy="180" r="10" />
      </g>

      {/* Sparkles */}
      <g fill="#ffb020">
        <path d="M155 320 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" />
        <path d="M340 320 l3 -7 l3 7 l7 3 l-7 3 l-3 7 l-3 -7 l-7 -3 z" />
      </g>
    </svg>
  );
}
